import { map } from 'ramda'

export default (icons) => map((icon) => () => icon, icons)
